export interface CommonPERequest {
  micromomentCampaignId: string;
  bannerCampaignId: string;
  offerCampaignId: string;
  membershipLevel: string;
  birthDay: boolean;
  sevenDaysBeforeBirthday: boolean;
  sevenDaysAfterBirthday: boolean;
  skyMilesAnniversary: boolean;
  ageRestrict: string;
  format: string;
  amexCardMember: string;
  newJoiner: boolean;
  profileSetUp: boolean;
  currentDate: string;
  skyclub: boolean;
}
